<div
    *ngIf="openAiPermission && !mention.isFinancialTimes"
    class="agpr-setPreferred-showTranslated"
    [ngClass]="{
        'agpr-setPreferred-showTranslated-noBottomPadding': isEditMention
    }"
>
    <agpr-mention-language-display
        [id]="id+'_language_actions'"
        [mention]="mention"
        [selectedTabIndex]="selectedTabIndex"
        [openAiPermission]="openAiPermission"
        [autoSave]="autoSave"
        [showActions]="true"
        [isEditMention]="isEditMention"
        [showLanguageLabel]="false"
        (tabChanged)="changeTab($event)"
        [isHalfWidth]="isLanguagePanelHalfWidth"
    ></agpr-mention-language-display>
    <div
        class="agpr-setPreferred-translate-buttons"
        *ngIf="mention?.mentionId"
    >
        <ng-container *ngIf="selectedTabIndex === tabIds.ORIGINAL">
            <agpr-button
                *ngIf="mention?.translation && mention.isTranslatedPreferred"
                [id]="id + '.setTranslatedPreferred'"
                [style]="buttonTypes.icon"
                class="agpr-setPreferred-translate-button agpr-setPreferred-translate-setPreferred"
                [icon]="'fa-regular fa-star'"
                (click)="setTranslatedPreferred()"
                [disabled]="mention?.translating"
                [tooltip]="'Mention.translate.setTranslatedPreferred'"
                tooltipPosition="top"
            ></agpr-button>
            <span
                *ngIf="mention?.translation && !mention.isTranslatedPreferred"
                [id]="id + '.noTranslationPreferred'"
                class="fa fa-star agpr-setPreferred-translate-setPreferred agpr-setPreferred-translate-setPreferredColor"
                [agprTooltip]="'Mention.translate.preferred'"
            ></span>
        </ng-container>
        <ng-container *ngIf="selectedTabIndex === tabIds.TRANSLATED">
            <agpr-button
                [id]="id + '.removeTranslated'"
                [style]="buttonTypes.icon"
                class="agpr-setPreferred-translate-button"
                [icon]="'fa-regular fa-duotone fa-trash-can'"
                (click)="removeTranslated()"
                [disabled]="mention?.translating"
                tooltip="Mention.translate.removeTranslated"
                tooltipPosition="top"
                [ariaDescribedBy]="id + '.removeTranslated'"
            ></agpr-button>
            <agpr-button
                *ngIf="!mention.isTranslatedPreferred"
                [id]="id + '.setTranslatedPreferred'"
                [style]="buttonTypes.icon"
                class="agpr-setPreferred-translate-button agpr-setPreferred-translate-setPreferred"
                [icon]="'fa-regular fa-star'"
                (click)="setTranslatedPreferred()"
                [disabled]="mention?.translating"
                [tooltip]="'Mention.translate.setTranslatedPreferred'"
                tooltipPosition="top"
            ></agpr-button>
            <span
                *ngIf="mention.isTranslatedPreferred"
                [id]="id + '.translationPreferred'"
                class="fa fa-star agpr-setPreferred-translate-setPreferred agpr-setPreferred-translate-setPreferredColor"
                [agprTooltip]="'Mention.translate.preferred'"
                tooltipPosition="top"
            ></span>
        </ng-container>
    </div>
</div>
